import * as types from "../actions/actionType";

const initialState = {
	types: [],
};

export default function typeReducer(state = initialState, action) {
	const { type, payload } = action;
	let newState = {};
	switch (type) {
		case types.FETCH_ALL_TYPES:
			newState = {
				...state,
				types: payload,
			};
			return newState;
		default:
			return state;
	}
}
